import { Component } from "@stencil/core";
import { store } from "@stencil/redux";
import { store as initialStore } from "@stores/store";

@Component({
  tag: "bcp-app",
})
export class BcpApp {
  componentWillLoad() {
    store.setStore(initialStore);
  }
}
